import { render, staticRenderFns } from "./otherInsurance.vue?vue&type=template&id=51f7c2b0&"
import script from "./otherInsurance.vue?vue&type=script&lang=js&"
export * from "./otherInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports